import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';
// import { cloneDeep } from 'lodash';
import { Select, Form, InputNumber, Carousel, Input, Switch, Button, Modal } from 'antd';
import { css } from '@emotion/core';
import { Row, SelectCol, To, Col, FormItem } from './styled';
import { Arrow } from '../../../components/common/styled';
import { SettingsFormHeader } from '../../common/SettingsFormHeader';
import { PolicySelectPanel, PolicyCard } from './BusinessPolicies';
import ActionCard from './ActionCard';
import { config } from './config';
import CountriesDropdown from '../../common/CountriesDropdown';
import { colors, fontSize, theme } from '../../../constants';
import { upperThreeToTwo, upperTwoToThree } from '../../../constants/countries';
import ENUMS from '../../../constants/enums';
import PopUpVideoLink from '../../common/PopUpVideoLink/PopUpVideoLink';
import { text2Medium } from '../../../constants/classes';

const { confirm } = Modal;
const { Option } = Select;
const { formItemLayout, slidesToScroll, slidesToShow } = config;

@inject('toastsStore')
@inject('localeStore')
@inject('sessionStore')
@inject('settingsStore')
@injectIntl
@Form.create()
@observer
class Listing extends Component {
  constructor(props) {
    super();
    const { defaultDestination, defaultSource, defaultSellersAccount } = props.markets;
    this.state = {
      selectedDestId: defaultDestination?.id ?? '',
      selectedSrcId: defaultSource?.id ?? '',
      selectedAccountCode: defaultSellersAccount?.id ?? '',
      selectedAccountName: defaultSellersAccount?.name ?? '',
      selectedPolicySetCode: '',
      scanning: false,
      showWarningText: false,
    };
    this.breadcrumb = {
      name: props.intl.formatMessage({ id: 'settingsModal.listing' }),
      clickHandler: this.closeEditPopup,
    };
  }

  componentDidMount() {
    const { selectedAccountCode, selectedDestId } = this.state;
    const {
      settingsStore: {
        policies: { setSelectedDestId, fetchUserOptedIn },
      },
      settingsStore: { subscription },
      policies,
    } = this.props;
    setSelectedDestId(selectedDestId);
    if (selectedAccountCode) {
      policies.fetchPolicyFormOptions(selectedAccountCode);
    }
    this.props.form.validateFieldsAndScroll({ offsetBottom: '50' });
    policies.fetchPolicyData().then(() => {
      fetchUserOptedIn(selectedDestId).then(response => {
        !response &&
          !Object.keys(subscription.billingPaypalAccount).length > 0 &&
          !policies.defaultPolicy.paymentPolicyText.length > 0 &&
          this.setState({ showWarningText: true });
      });
    });

    this.props.updateBreadcrumbs(this.breadcrumb, true);
    if (policies.noPolicyLoaded || this.props.listingClone.noListingOptions) {
      this.handleDestChange(selectedDestId);
    }
  }

  // componentWillUnmount() {
  // this.props.form.validateFields(err => {
  //   if (err) {
  //     this.props.preventTabChange();
  //   }
  // });
  // this.props.policies.resetPolicyList();
  // }

  handleSrcChange = id => {
    this.setState({ selectedSrcId: id }, () => {
      this.fetchPolicyData();
      this.fetchListOptions();
    });
  };

  handleDestChange = id => {
    const {
      settingsStore: {
        policies: { setSelectedDestId },
      },
    } = this.props;
    setSelectedDestId(id);
    this.props.markets.fetchSellersAccounts(id);
    this.setState({ selectedDestId: id }, () => {
      this.fetchPolicyData();
      this.fetchListOptions();
    });
  };

  handleAccountChange = code => {
    this.setState({ selectedAccountCode: code }, () => {
      this.fetchPolicyData(code);
      this.fetchListOptions();
      this.props.policies.fetchPolicyFormOptions(code);
    });
  };

  fetchListOptions = () => {
    const { selectedSrcId: src, selectedDestId: dest, selectedAccountCode: account } = this.state;
    if (src && dest && account) {
      this.props.fetchListingOptions(src, account, dest);
    }
  };

  fetchPolicyData = () => {
    const { selectedSrcId: src, selectedAccountCode: account } = this.state;
    if (src && account) {
      this.props.policies.fetchPolicyData(src, account);
    }
  };

  showEditPopup = ({ isNew, code }) => {
    if (isNew) {
      const { policies } = this.props;
      policies.addNewPolicy();
    }
    this.props.policies.setSelectedPolicySetCode(code);
    this.setState({
      isEdit: true,
      selectedPolicySetCode: code,
    });
  };

  closeEditPopup = () => {
    this.props.updateBreadcrumbs(this.breadcrumb, true);
    this.setState({
      isEdit: false,
      selectedPolicySetCode: null,
    });
  };

  saveEditPolicy = (policyId, obj) => {
    const { selectedDestId, selectedSrcId, selectedAccountCode } = this.state;
    const newObj = {
      ...obj,
      sellerAccountCode: selectedAccountCode,
      sourceMarketplaceId: selectedSrcId,
      destinationMarketplaceId: selectedDestId,
    };
    console.log(policyId, newObj);
  };

  toggleDefaultPolicy = policy => {
    const { selectedAccountCode } = this.state;
    if (selectedAccountCode) {
      policy.toggleDefaultPolicy();
    }
  };

  deletePolicy = policy => policy.deletePolicySet();

  clonePolicy = ({ id, ...policy }) => {
    const {selectedAccountCode,selectedSrcId,selectedDestId}=this.state
    this.props.policies.setSelectedPolicySetCode(policy.code);
    const { selectedPolicySet,fetchPolicySets } = this.props.policies;
    selectedPolicySet.policySelectedOptions.setName(`Copy - ${selectedPolicySet.name}`)
    selectedPolicySet.policySelectedOptions.setShippingPolicyCode(selectedPolicySet.shippingPolicyText)
    selectedPolicySet.policySelectedOptions.setPaymentPolicyCode(selectedPolicySet.paymentPolicyText)
    selectedPolicySet.policySelectedOptions.setReturnsPolicyCode(selectedPolicySet.returnPolicyText)
    selectedPolicySet.createNewPolicySet(selectedAccountCode,selectedSrcId,selectedDestId).then(()=>fetchPolicySets());
  };

  connectToSaveButton = inputHandler => inputValue => {
    inputHandler(inputValue);
    const { updateApplyBtn } = this.props;
    updateApplyBtn();
  };

  scanVero = () => {
    const { selectedAccountCode } = this.state;
    const {
      scanUserByToken,
      toastsStore: { showToast },
    } = this.props;
    this.setState({ scanning: true });
    scanUserByToken(selectedAccountCode).then(res => {
      this.setState({ scanning: false });
      if (res) {
        showToast({
          type: ENUMS.TOAST_TYPES.INFO,
          message: `Scan finished successfully`,
        });
      } else {
        showToast({
          type: ENUMS.TOAST_TYPES.WARNING,
          message: 'Error',
        });
      }
    });
  };

  showConfirmToEnd = () => {
    confirm({
      content:
        'This action will end all listings with detected VERO violations. Are you sure you want to continue?',
      onOk: this.scanVero,
      onCancel() {},
    });
  };

  render() {
    const {
      listingClone,
      policies,
      updateBreadcrumbs,
      markets: { sources, destinations, sellersAccounts },
      form: { getFieldDecorator },
      selectTab,
      intl,
      userProfile,
      listingOptionsLoading,
      localeStore: { isJA },
      sessionStore: { isNonApi },
    } = this.props;
    const {
      selectedPolicySetCode,
      selectedDestId,
      selectedSrcId,
      selectedAccountCode,
      selectedAccountName,
      isEdit,
      scanning,
      showWarningText,
    } = this.state;

    return (
      <div>
        {isEdit ? (
          <div>
            <PolicySelectPanel
              selectedAccountCode={selectedAccountCode}
              selectedSrcId={selectedSrcId}
              closePopup={this.closeEditPopup}
              selectedPolicySetCode={selectedPolicySetCode}
              updateBreadcrumbs={updateBreadcrumbs}
              selectedDestId={selectedDestId}
            />
          </div>
        ) : (
          <div>
            <Row>
              <SelectCol justifyContent="space-between">
                <span>
                  <FormattedMessage
                    id="common.sourceMarketplace"
                    defaultMessage="Source Marketplace"
                  />
                </span>
                <Select onChange={this.handleSrcChange} defaultValue={selectedSrcId}>
                  {sources.map(source => (
                    <Option key={source.name} value={source.id}>
                      {source.name}
                    </Option>
                  ))}
                </Select>
              </SelectCol>
              <To style={{ display: 'flex', alignItems: 'center' }}>TO</To>
              <SelectCol justifyContent="space-between">
                <span>
                  <FormattedMessage
                    id="pricing.destinationMarketplace"
                    defaultMessage="Destination Marketplace"
                  />
                </span>
                <Select onChange={this.handleDestChange} defaultValue={selectedDestId}>
                  {destinations.map(destination => (
                    <Option key={destination.name} value={destination.id}>
                      {destination.name}
                    </Option>
                  ))}
                </Select>
              </SelectCol>
              <SelectCol justifyContent="space-between">
                <span>
                  <FormattedMessage id="pricing.accounts" defaultMessage="Accounts" />
                </span>
                <Select
                  showSearch
                  onChange={this.handleAccountChange}
                  defaultValue={selectedAccountName}
                >
                  {sellersAccounts.map(account => (
                    <Option key={account.id} value={account.id}>
                      {account.name}
                    </Option>
                  ))}
                </Select>
              </SelectCol>
            </Row>
            {selectedAccountCode ? (
              <>
                <SettingsFormHeader
                  marginBottom="0.5em"
                  id="listing.scanVero"
                  defaultMessage="SCAN VERO"
                />
                <FormItem
                  css={css`
                    margin-top: 1em;
                    .ant-form-item-label {
                      width: 70%;
                    }
                  `}
                  fullWidth
                  {...formItemLayout}
                  label={
                    <div style={{ whiteSpace: 'normal' }}>
                      <FormattedMessage
                        id="listing.scanAccountVero"
                        defaultMessage="Scan selected seller account for VERO Violations"
                      />
                    </div>
                  }
                >
                  <Button
                    htmlType="submit"
                    type="primary"
                    disabled={!selectedAccountCode || scanning}
                    onClick={this.showConfirmToEnd}
                    loading={scanning}
                  >
                    {'Scan & End'}
                  </Button>
                </FormItem>
                <SettingsFormHeader
                  marginBottom="0.5em"
                  id="listing.businessPolicies"
                  defaultMessage="BUSINESS POLICIES"
                />
                <Row justifyContent="space-around">
                  {!isNonApi ? (
                    <Col
                      style={{
                        width: '15%',
                      }}
                    >
                      <ActionCard
                        iconType="plus-circle"
                        intlId="listing.newPolicy"
                        isJA={isJA}
                        clickHandler={() => this.showEditPopup({ isNew: true })}
                      />
                    </Col>
                  ) : (
                    false
                  )}
                  <div style={isNonApi ? { width: '100%' } : { width: 'calc(85% - 60px)' }}>
                    <Carousel
                      infinite={false}
                      dots={false}
                      arrows
                      swipeToSlide
                      slidesToShow={slidesToShow}
                      slidesToScroll={slidesToScroll}
                      nextArrow={<Arrow type="carousel-arrow-r" />}
                      prevArrow={<Arrow flip type="carousel-arrow-r" />}
                    >
                      {policies.policyList &&
                        policies.policyList.map(policy => (
                          <PolicyCard
                            isNonApi={isNonApi}
                            toggleDefault={() => this.toggleDefaultPolicy(policy)}
                            deletePolicy={() => this.deletePolicy(policy)}
                            clonePolicy={() => this.clonePolicy(policy)}
                            isDefault={policy.isDefault}
                            key={policy.code}
                            handleClick={() =>
                              !isNonApi ? this.showEditPopup({ code: policy.code }) : null
                            }
                            policy={policy}
                          />
                        ))}
                    </Carousel>
                  </div>
                </Row>
                {showWarningText && (
                  <Row>
                    <div
                      css={css`
                        display: flex;
                        width: 100%;
                        margin-top: 10px;
                        margin-left: 12px;
                        color: red;
                      `}
                    >
                      Please connect a paypal account or opted in your ebay account in order to
                      create payment policy !
                    </div>
                  </Row>
                )}
                <Row>
                  <div
                    css={css`
                      display: flex;
                      justify-content: space-evenly;
                      width: 100%;
                      margin-top: 10px;
                    `}
                  >
                    <PopUpVideoLink
                      message="How To Build A Shipping Policy:"
                      videoUrl="https://vimeo.com/475871363/634ecd2201"
                      extraCSS={`
                        margin-bottom: 20px;
                        text-decoration: underline;
                        &:hover {
                          text-decoration: underline;
                        }
                        ${text2Medium}
                        font-size: ${theme.fontSize.medium};
                      `}
                    />
                    <PopUpVideoLink
                      message="How To Build A Return Policy:"
                      videoUrl="https://vimeo.com/475871363/634ecd2201"
                      extraCSS={`
                        margin-bottom: 20px;
                        text-decoration: underline;
                        &:hover {
                          text-decoration: underline;
                        }
                        ${text2Medium}
                        font-size: ${theme.fontSize.medium};
                      `}
                    />
                    <a
                      css={css`
                        color: ${theme.colors.blueMed} !important;
                        text-decoration: underline;
                        font-size: ${fontSize.small};
                        &:hover {
                          color: ${theme.colors.blueLight} !important;
                        }
                      `}
                      href="/assets/sampleFiles/RecommendedBusinessPoliciesInEBay/RecommendedBusinessPoliciesInEBay.html"
                      // eslint-disable-next-line react/jsx-no-target-blank
                      target="_blank"
                    >
                      RecommendedBusinessPoliciesInEBay
                    </a>
                  </div>
                </Row>
              </>
            ) : (
              <Row>
                <div
                  css={css`
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    height: 12em;
                    width: 100%;
                  `}
                >
                  <span
                    css={css`
                      padding: 1em;
                    `}
                  >
                    {intl.formatMessage({ id: 'settingsModal.noDestinationConnected' })}
                  </span>
                  <a
                    css={css`
                      display: block;
                      font-family: Roboto;
                      font-size: ${fontSize.medium};
                      line-height: 1.07;
                      letter-spacing: 0px;
                      color: ${colors.blueMed};
                      text-decoration: underline;
                    `}
                    onClick={() => selectTab(ENUMS.SETTINGS_TABS.CONNECT)}
                  >
                    <FormattedMessage id="settingsModal.connectDestination" />
                  </a>
                </div>
              </Row>
            )}
            <Form>
              {!!selectedAccountCode && (
                <>
                  <SettingsFormHeader id="listing.itemLocation" defaultMessage="Item Location" />
                  <FormItem
                    {...formItemLayout}
                    label={<FormattedMessage id="listing.cityState" defaultMessage="City State" />}
                  >
                    {listingOptionsLoading ? (
                      <FormattedMessage id="common.loading" defaultMessage="loading..." />
                    ) : (
                      getFieldDecorator('cityState', {
                        initialValue: listingClone.listingOptions.cityState,
                        rules: [{ required: true, message: 'Please enter the City or State!' }],
                      })(
                        <Input
                          onChange={this.connectToSaveButton(listingClone.setCityState)}
                          type="text"
                          style={{ width: '120px' }}
                        />,
                      )
                    )}
                  </FormItem>
                  <FormItem
                    {...formItemLayout}
                    label={<FormattedMessage id="common.country" defaultMessage="Country" />}
                    required
                  >
                    {listingOptionsLoading ? (
                      <FormattedMessage id="common.loading" defaultMessage="loading..." />
                    ) : (
                      <CountriesDropdown
                        countryFormat="upperTwo"
                        onChange={this.connectToSaveButton(listingClone.setCountry)}
                        borderColor={`${theme.disabledBorder} !important`}
                        borderColorHover="#40a9ff"
                        width="120px"
                        value={
                          listingClone.listingOptions?.country?.length === 3 &&
                          upperThreeToTwo[listingClone.listingOptions.country]
                            ? listingClone.listingOptions.country
                            : upperTwoToThree[listingClone.listingOptions.country] ?? ''
                        }
                      />
                    )}
                  </FormItem>
                  <FormItem
                    {...formItemLayout}
                    label={<FormattedMessage id="common.postalCode" defaultMessage="Postal Code" />}
                  >
                    {listingOptionsLoading ? (
                      <FormattedMessage id="common.loading" defaultMessage="loading..." />
                    ) : (
                      getFieldDecorator('postalCode', {
                        initialValue: listingClone.listingOptions.postalCode,
                      })(
                        <Input
                          onChange={this.connectToSaveButton(listingClone.setPostalCode)}
                          type="text"
                          style={{ width: '120px' }}
                        />,
                      )
                    )}
                  </FormItem>
                </>
              )}
              {
                // listingClone.listingOptions.country === 'USA' && (
                //   <React.Fragment>
                //     <SettingsFormHeader id="listing.tax" defaultMessage="TAX" />
                //     <FormItem
                //       {...formItemLayout}
                //       label={
                //         <FormattedMessage id="listing.enableSalesTax" defaultMessage="Enable Sales Tax" />
                //       }
                //     >
                //       {getFieldDecorator('enableSalesTax', {
                //         initialValue: listingClone.listingOptions.enableSalesTax,
                //         valuePropName: 'checked',
                //       })(<Switch onChange={this.connectToSaveButton(listingClone.setEnableSalesTax)} />)}
                //     </FormItem>
                //   </React.Fragment>
                // )
              }
              <SettingsFormHeader
                marginBottom="0.5em"
                id="common.globalPrefs"
                defaultMessage="GLOBAL PREFERENCES"
              />
              <FormItem
                css={css`
                  .ant-form-item-label {
                    width: 50%;
                  }
                `}
                fullWidth
                {...formItemLayout}
                label={
                  <div style={{ whiteSpace: 'normal' }}>
                    <FormattedMessage
                      id="listing.allowDuplicatesOnRelatedAccounts"
                      defaultMessage="Allow list to unlinked destination accounts"
                    />
                  </div>
                }
              >
                {getFieldDecorator('allowDuplicatesOnRelatedAccounts', {
                  initialValue: userProfile.allowDuplicatesOnRelatedAccounts,
                  valuePropName: 'checked',
                })(
                  <Switch
                    onChange={this.connectToSaveButton(
                      userProfile.setAllowDuplicatesOnRelatedAccounts,
                    )}
                  />,
                )}
              </FormItem>
              {!!selectedAccountCode && (
                <>
                  <SettingsFormHeader
                    id="listing.templatesForListing"
                    defaultMessage="TEMPLATES FOR LISTING"
                  />
                  <FormItem
                    {...formItemLayout}
                    label={
                      <FormattedMessage
                        id="listing.defaultTemplate"
                        defaultMessage="Default Template"
                      />
                    }
                  >
                    {getFieldDecorator('defaultTemplate', {
                      initialValue: listingClone.listingOptions.defaultHtmlTemplateId,
                    })(
                      <Select
                        onChange={this.connectToSaveButton(listingClone.setDefaultHtmlTemplateId)}
                        style={{ width: '120px' }}
                      >
                        {listingClone.getTemplateList.map(template => (
                          <Option key={template.id} value={template.id}>
                            {template.name}
                          </Option>
                        ))}
                      </Select>,
                    )}
                  </FormItem>
                  <SettingsFormHeader
                    id="listing.sourceListingPreferences"
                    defaultMessage="LISTING PREFERENCES"
                  />
                  <FormItem
                    {...formItemLayout}
                    label={
                      <FormattedMessage
                        id="listing.maxShippingTime"
                        defaultMessage="Maximal Shipping Time"
                      />
                    }
                  >
                    {getFieldDecorator('maxShippingTime', {
                      initialValue: listingClone.listingOptions.maximalShippingTime,
                    })(
                      <InputNumber
                        onChange={this.connectToSaveButton(listingClone.setMaximalShippingTime)}
                        type="number"
                        style={{ width: '120px' }}
                      />,
                    )}
                    &nbsp;
                    <FormattedMessage id="common.days" defaultMessage="Days" />
                  </FormItem>
                  <FormItem
                    {...formItemLayout}
                    label={
                      <FormattedMessage
                        id="listing.minQuantityInStock"
                        defaultMessage="Minimum Quantity in Stock"
                      />
                    }
                  >
                    {getFieldDecorator('minQuantityInStock', {
                      initialValue: listingClone.listingOptions.minimalQuantityInStock,
                    })(
                      <InputNumber
                        onChange={this.connectToSaveButton(listingClone.setMinimalQuantityInStock)}
                        type="number"
                        style={{ width: '120px' }}
                      />,
                    )}
                    &nbsp;
                    <FormattedMessage id="listing.items" defaultMessage="Items" />
                  </FormItem>
                  <SettingsFormHeader
                    id="listing.defaultQuantity"
                    defaultMessage="DEFAULT QUANTITY"
                  />
                  <FormItem
                    {...formItemLayout}
                    label={
                      <FormattedMessage
                        id="listing.defaultQuantityToList"
                        defaultMessage="Default Quantity To List"
                      />
                    }
                  >
                    {getFieldDecorator('defaultQuantityToList', {
                      initialValue: listingClone.listingOptions.defaultQuantityToList,
                    })(
                      <InputNumber
                        onChange={this.connectToSaveButton(listingClone.setDefaultQuantityToList)}
                        type="number"
                        style={{ width: '120px' }}
                      />,
                    )}
                    &nbsp;
                    <FormattedMessage id="listing.items" defaultMessage="Items" />
                  </FormItem>
                </>
              )}
            </Form>
          </div>
        )}
      </div>
    );
  }
}

Listing.propTypes = {
  toastsStore: PropTypes.object,
  userProfile: PropTypes.object,
  markets: PropTypes.object,
  listingClone: PropTypes.object,
  fetchListingOptions: PropTypes.func,
  listingOptionsLoading: PropTypes.bool,
  scanUserByToken: PropTypes.func,
  policies: PropTypes.object,
  localeStore: PropTypes.object,
  form: PropTypes.object,
  intl: PropTypes.object,
  updateBreadcrumbs: PropTypes.func,
  // preventTabChange: PropTypes.func,
  editPolicy: PropTypes.func,
  updateApplyBtn: PropTypes.func,
  selectTab: PropTypes.func,
};

export default Listing;
